import { useCallback, useState } from 'react';

export const useThumbnailErrors = () => {
  const [thumbnailErrors, setThumbnailErrors] = useState<Set<string>>(new Set());

  const handleThumbnailError = useCallback((mediaId: string) => {
    setThumbnailErrors((prev) => new Set(prev).add(mediaId));
  }, []);

  return {
    thumbnailErrors,
    handleThumbnailError,
  };
};
